import { StylishNewSearchBar } from 'components/DesignSystems/New/StylishNewSearchBar';
import StylishNewSelect from 'components/DesignSystems/New/StylishNewSelect';
import { useAllIncidents } from 'components/IAP/hooks/incidentHooks';
import { useAors } from 'hooks/useAors';
import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';

interface NotificationsFilterBarProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  selectedAorId: string | null;
  onAorChange: (aorId: string | null) => void;
  selectedIncidentId: string | null;
  onIncidentChange: (incidentId: string | null) => void;
}

const NotificationsFilterBar: React.FC<NotificationsFilterBarProps> = ({
  searchText,
  onSearchChange,
  selectedAorId,
  onAorChange,
  selectedIncidentId,
  onIncidentChange,
}) => {
  const { data: aors = [] } = useAors();
  const { data: incidents = [] } = useAllIncidents();

  const aorOptions = useMemo(
    () =>
      aors.map((aor) => ({
        value: aor.id,
        label: aor.name,
      })),
    [aors]
  );

  const incidentOptions = useMemo(
    () =>
      incidents.map((incident) => ({
        value: incident.id,
        label: incident.name,
      })),
    [incidents]
  );
  return (
    <div className="p-2">
      <StylishNewSearchBar
        value={searchText}
        onChangeSearchTerm={onSearchChange}
        placeholder="Search"
      />
      <Row className="mt-2">
        <Col className="d-flex">
          <div className="d-flex align-items-center gap-2 w-100">
            <span>Incident:</span>
            <div className="flex-grow-1">
              <StylishNewSelect
                options={incidentOptions}
                value={incidentOptions.find(
                  (opt) => opt.value === selectedIncidentId
                )}
                isClearable
                onChange={(opt: { value: UUID; label: string } | null) =>
                  onIncidentChange(opt?.value ?? null)
                }
              />
            </div>
          </div>
        </Col>
        <Col className="d-flex">
          <div className="d-flex align-items-center gap-2 w-100">
            <span>AOR:</span>
            <div className="flex-grow-1">
              <StylishNewSelect
                options={aorOptions}
                value={aorOptions.find((opt) => opt.value === selectedAorId)}
                isClearable
                onChange={(opt: { value: UUID; label: string } | null) =>
                  onAorChange(opt?.value ?? null)
                }
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default NotificationsFilterBar;
